// export const categoryDetails = [
//     {
//         id: 1,
//         default: require('@/assets/眼眉/1_02.jpg'),
//         active: require('@/assets/眼眉/2_02.jpg'),
//         describe1: '柔光幻彩单色眼影',
//         describe2: '百种眼色 玩转眼妆',
//         links: 'https://detail.tmall.com/item.htm?spm=a1z10.3-b-s.w4011-18828674639.86.7fa8e061lR0Fh9&id=575448892562&rn=4d52cd39f201fc838a8ce1545454e19a&abbucket=17'

//     },
//     {
//         id: 2,
//         default: require('@/assets/眼眉/1_05.jpg'),
//         active: require('@/assets/眼眉/2_03.jpg'),
//         describe1: '七色玩趣组合盘',
//         describe2: '一盘搞定全脸妆容',
//         links: 'https://detail.tmall.com/item.htm?spm=a1z10.3-b-s.w4011-18828674639.60.7fa8e061zRL9J3&id=597894450019&rn=e1fbce851d195488b9b0768d75a5648d&abbucket=17'

//     },
//     {
//         id: 3,
//         default: require('@/assets/眼眉/1_11.jpg'),
//         active: require('@/assets/眼眉/2_04.jpg'),
//         describe1: '云柔朵朵四色眼影',
//         describe2: '新手四色 清透闪耀',
//         links: 'https://detail.tmall.com/item.htm?spm=a1z10.3-b-s.w4011-18828674639.136.1983e061Fvkkm5&id=619710814713&rn=fddb45f3da2270310041ac92e7b73a2a&abbucket=17'
//     },
//     {
//         id: 4,
//         default: require('@/assets/眼眉/1_03.jpg'),
//         active: require('@/assets/眼眉/2_05.jpg'),
//         describe1: '二十色「油画盘」',
//         describe2: '一盘领略梦幻眼妆',
//         links: 'https://detail.tmall.com/item.htm?spm=a1z10.3-b-s.w4011-18828674639.48.5dd3e0611k1kWC&id=644212343550&rn=0215805f08b7799740294a071cfd1483&abbucket=17 '
//     },
//     {
//         id: 5,
//         default: require('@/assets/眼眉/1_04.jpg'),
//         active: require('@/assets/眼眉/2_10.jpg'),
//         describe1: '二十色「日落盘」',
//         describe2: '质感配色 描绘双眸神采',
//         links: 'https://detail.tmall.com/item.htm?spm=a1z10.3-b-s.w4011-18828674639.48.5dd3e0611k1kWC&id=644212343550&rn=0215805f08b7799740294a071cfd1483&abbucket=17'
//     },
//     {
//         id: 6,
//         default: require('@/assets/眼眉/1_10.jpg'),
//         active: require('@/assets/眼眉/2_11.jpg'),
//         describe1: '钻石眼泪液体眼影',
//         describe2: '梦幻光耀 点亮眼妆',
//         links: 'https://detail.tmall.com/item.htm?spm=a1z10.3-b-s.w4011-18828674639.80.7fa8e061zRL9J3&id=588081990545&rn=e1fbce851d195488b9b0768d75a5648d&abbucket=17'
//     }
// ]

export const categoryDetails = [
    {
        id: 1,
        default: require('@/assets/眼眉/1_1_1.jpg'),
        active: require('@/assets/眼眉/1_1_2.jpg'),
        describe1: '柔光幻彩单色眼影',
        describe2: '晴彩玩色 单色不单调',
        links: 'https://detail.tmall.com/item.htm?spm=a1z10.3-b-s.w4011-18828674639.86.7fa8e061lR0Fh9&id=575448892562&rn=4d52cd39f201fc838a8ce1545454e19a&abbucket=17'

    },
    {
        id: 2,
        default: require('@/assets/眼眉/1_2_1.jpg'),
        active: require('@/assets/眼眉/1_2_2.jpg'),
        describe1: '云柔朵朵四色眼影',
        describe2: '新手四色 清透闪耀',
        links: 'https://detail.tmall.com/item.htm?spm=a1z10.3-b-s.w4011-18828674639.136.1983e061Fvkkm5&id=619710814713&rn=fddb45f3da2270310041ac92e7b73a2a&abbucket=17'
    },
    {
        id: 3,
        default: require('@/assets/眼眉/1_3_1.jpg'),
        active: require('@/assets/眼眉/1_3_2.jpg'),
        describe1: '七色玩趣组合盘',
        describe2: '一盘搞定全脸妆容',
        links: 'https://detail.tmall.com/item.htm?spm=a1z10.3-b-s.w4011-18828674639.60.7fa8e061zRL9J3&id=597894450019&rn=e1fbce851d195488b9b0768d75a5648d&abbucket=17'

    },
        {
        id: 4,
        default: require('@/assets/眼眉/1_03.jpg'),
        active: require('@/assets/眼眉/2_05.jpg'),
        describe1: '二十色「油画盘」',
        describe2: '一盘领略梦幻眼妆',
        links: 'https://detail.tmall.com/item.htm?spm=a1z10.3-b-s.w4011-18828674639.48.5dd3e0611k1kWC&id=644212343550&rn=0215805f08b7799740294a071cfd1483&abbucket=17 '
    },
    {
        id: 5,
        default: require('@/assets/眼眉/1_04.jpg'),
        active: require('@/assets/眼眉/2_10.jpg'),
        describe1: '二十色「日落盘」',
        describe2: '质感配色 描绘双眸神采',
        links: 'https://detail.tmall.com/item.htm?spm=a1z10.3-b-s.w4011-18828674639.48.5dd3e0611k1kWC&id=644212343550&rn=0215805f08b7799740294a071cfd1483&abbucket=17'
    },
    {
        id: 6,
        default: require('@/assets/眼眉/1_4_1.jpg'),
        active: require('@/assets/眼眉/1_4_2.jpg'),
        describe1: '星辰盈璨液体眼影',
        describe2: '三重质地 持久点睛',
        links: 'https://detail.tmall.com/item.htm?app=chrome&bxsign=scdhYKqGuCWvCSXITJ2XjMwOIBJYDYC2OB3AAVl847qcRPbE7LkFNcIAAAzyhg0PV3wE45qh8S0tmEhY625EftkQnyqYsNc9d_I7FTH_Ou59QmM7xevaPZqId2yA0ifMXA-&cpp=1&id=588081990545&origin_price=59&price=29.8&shareUniqueId=19939301095&share_crt_v=1&shareurl=true&short_name=h.UmS3A70&sourceType=item&sp_abtk=gray_1_code_simpleios2&sp_tk=a0hhcWQ2a3NHS0w=&spm=a2159r.13376460.0.0&suid=90E08D6D-E456-4A2D-B86E-CB6C7B194830&tbSocialPopKey=shareItem&tk=kHaqd6ksGKL%20CZ&un=26037f64cf4c5ce5b2a02c4eb1ea31ed&un_site=0&ut_sk=1.X97pKKL5aq8DAOKGXjarDDr1_21380790_1675753324599.Copy.1 '
    }
]